import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import deepmerge from 'deepmerge';
import { zIndices } from '../const.esm.js';
import { generateFullScaleArray } from '../scales.esm.js';
import { forms } from '../theme-keys/index.esm.js';
import createBreakpoints from '../theme-keys/breakpoints.esm.js';
import getSizes from '../theme-keys/sizes.esm.js';
import { colors } from '../theme-keys/colors.esm.js';
import { badges } from '../../components/badge/variants.esm.js';
import getBorders from '../theme-keys/borders.esm.js';
import { borderWidths } from '../theme-keys/border-widths.esm.js';
import { anchors } from '../theme-keys/anchors.esm.js';
import buttons from '../../components/button/variants.esm.js';
import { cards } from '../theme-keys/cards.esm.js';
import { elevations } from '../theme-keys/elevations.esm.js';
import getGradients from '../theme-keys/gradients.esm.js';
import { grids } from '../theme-keys/grids.esm.js';
import { headings } from '../theme-keys/headings.esm.js';
import { layout } from '../theme-keys/layout.esm.js';
import { lists } from '../theme-keys/lists.esm.js';
import getRadii from '../theme-keys/radii.esm.js';
import { scrollbar } from '../theme-keys/scrollbar.esm.js';
import getShadows from '../theme-keys/shadows.esm.js';
import { styles } from '../theme-keys/styles.esm.js';
import { tables } from '../theme-keys/tables.esm.js';
import { tabs } from '../theme-keys/tabs.esm.js';
import tags from '../theme-keys/tags.esm.js';
import { text } from '../theme-keys/text.esm.js';
import { tooltips } from '../theme-keys/tooltips.esm.js';
import { transitions } from '../theme-keys/transitions.esm.js';
import { fonts } from '../theme-keys/fonts.esm.js';

function getBaseTheme () {
  var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'px';
  var brand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'suite';
  var brandColors = deepmerge(colors, brand === 'loop-net' ? {
    primary: '#cf0000',
    secondary: '#961e00',
    muted: '#ffebeb',
    accent: '#721700',
    modes: {
      dark: {
        primary: '#d65d5d'
      }
    }
  } : brand === 'apartment' ? {
    primary: '#77b800',
    secondary: '#427b01',
    muted: '#ffebeb',
    accent: '#077eb1',
    modes: {
      dark: {
        primary: '#77b800'
      }
    }
  } : {});
  return _objectSpread2(_objectSpread2({
    contextId: 'base',
    useCustomProperties: false,
    useColorSchemeMediaQuery: false,
    useRootStyles: false,
    // need to be explicit other wise it result in a redundant Global style tag
    useLocalStorage: false,
    baseUnit: unit,
    breakpoints: createBreakpoints()
  }, fonts), {}, {
    badges: badges,
    borders: getBorders(colors),
    borderWidths: borderWidths,
    anchors: anchors,
    buttons: buttons,
    forms: forms,
    cards: cards,
    colors: brandColors,
    elevations: elevations,
    emSpace: generateFullScaleArray(1, 'em', 2, 64),
    fontSizes: unit === 'px' ? generateFullScaleArray(24, 'px') : generateFullScaleArray(24 / 16, 'rem'),
    // prefer rem unit but until all application remove root font override we have to stay with px unit.
    gradients: getGradients(colors),
    grids: grids,
    headings: headings,
    layout: layout,
    lists: lists,
    radii: getRadii(unit),
    scrollbar: scrollbar,
    shadows: getShadows(colors),
    sizes: getSizes(unit),
    space: unit === 'px' ? generateFullScaleArray(16, 'px', 2, 64) : generateFullScaleArray(1, 'rem', 2, 64),
    // prefer rem unit but until all application remove root font override we have to stay with px unit.
    styles: styles,
    tables: tables,
    tabs: tabs,
    tags: tags,
    text: text,
    tooltips: tooltips,
    transitions: transitions,
    zIndices: zIndices
  });
}

export default getBaseTheme;
//# sourceMappingURL=get-base-theme.esm.js.map
